import { useLocation } from "react-router-dom";

import TestimonialSection from "./common/TestimonialSection";
import ConnectWithUsForm from "./common/ConnectWithUsForm";


interface ContactSectionProps {
  hideTestimonials?: boolean;
}

const ContactSection: React.FC<ContactSectionProps> = ({ hideTestimonials = false }) => {
  const location = useLocation();
  const isAttestationPage = location.pathname === "/attestation-details";
  const shouldHideTestimonials = hideTestimonials || isAttestationPage;

  return (
    <section className="bg-white font-manrope">
      {!shouldHideTestimonials && (
        <>
          {/* Testimonials Section */}
          <div className="bg-primary-lightblue md:py-10 py-8 rounded-b-[85%]" />
          <TestimonialSection />
          <div className="bg-primary-lightblue md:py-14 py-10 rounded-t-[85%]" />
        </>
      )}
      {/* Contact Form Section */}
      <ConnectWithUsForm wrapperClassName="md:pt-20 md:pb-0 px-4 pb-10" imageClassName="w-full h-auto max-w-lg mx-auto rounded" />
    </section>
  );
};
export default ContactSection;
